import React, { useEffect } from 'react';
import { Tooltip, Typography } from 'antd';
import { useLazyGetVipCustomerByCustomerCodeQuery } from '../../services';
import { RightCircleOutlined } from '@ant-design/icons';

interface VipCustomerLookupProps {
  customerCode: string;
}

const VipCustomerLookup: React.FC<VipCustomerLookupProps> = ({ customerCode }) => {
  const [fetchVipCustomer, { data: vipCustomerData, isLoading, isFetching }] =
    useLazyGetVipCustomerByCustomerCodeQuery();

  useEffect(() => {
    if (customerCode.length === 13) {
      fetchVipCustomer(customerCode);
    }
  }, [customerCode, fetchVipCustomer]);

  const showLoading = isLoading || isFetching;

  const isVip = !!vipCustomerData?.data;

  if (customerCode.length !== 13) {
    return null;
  }

  return (
    <div>
      {showLoading ? (
        <Typography.Text>Đang kiểm tra...</Typography.Text>
      ) : (
        <>
          {isVip ? (
            <Tooltip
              title={
                <div className={'test-tooltip flex flex-col space-y-2'}>
                  <div>KH Vip: {vipCustomerData?.data?.vipCustomerId}</div>
                  <div>Mã KH: {vipCustomerData?.data?.code}</div>
                  <div>SĐT: {vipCustomerData?.data?.phoneNumber}</div>
                  <div className={'w-full'}>Ghi chú: {vipCustomerData?.data?.note}</div>
                </div>
              }
              placement={'right'}
              color={'#87d068'}
              className={'cursor-pointer'}
            >
              <div className='animate-fadeIn mb-2 flex items-center gap-2 rounded-lg border border-green-500 bg-green-50 px-4 py-3 shadow-sm'>
                <Typography.Text className='text-normal font-semibold text-green-600'>
                  <RightCircleOutlined />
                </Typography.Text>
                <Typography.Text className='text-xs font-semibold text-green-600'>KHÁCH HÀNG VIP</Typography.Text>
              </div>
            </Tooltip>
          ) : (
            ''
          )}
        </>
      )}
    </div>
  );
};

export default VipCustomerLookup;
